var render = function render(){var _vm=this,_c=_vm._self._c;return _c('boxwrap',{staticClass:"user--inner"},[_c('toolbar'),_c('boxwrap-contents')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }